import React, { useEffect, useState } from 'react';
import { MenuOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import { useLogout } from '@app/utils';
import {
  AntdConfigProvider,
  AntdPopover,
  AntdTypography,
  Button,
  SignOut,
  useTheme,
  isYWC,
  AntdBadge,
} from '@ui';

import '../../nav-bar.css';
import { NavBarLink } from '../../types';

const { Text } = AntdTypography;

interface MobileNavBarProps {
  links: NavBarLink[];
}

export const MobileNavBar = ({ links }: MobileNavBarProps) => {
  const { t } = useTranslation();
  const { logout } = useLogout();
  const { pathname } = useLocation();
  const { textColor } = useTheme();

  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  const toggleOpenPopover = () => {
    setOpenMobileMenu(!openMobileMenu);
  };

  useEffect(() => {
    setOpenMobileMenu(false);
  }, [pathname]);

  return (
    <AntdConfigProvider theme={{ token: { borderRadius: 0 } }}>
      <AntdPopover
        content={
          <div className="flex flex-col items-start gap-4 h-auto bg-white w-fit mx-auto my-3">
            {links?.map((link) => {
              const LinkIcon = link.icon;
              return (
                <NavLink
                  key={link.name}
                  to={link.link}
                  className="flex items-center text-primary-600 h-full"
                >
                  <AntdBadge
                    overflowCount={5}
                    count={link.count}
                    styles={{ indicator: { borderRadius: 4, opacity: 0.9 } }}
                    className="text-inherit flex items-center flex-nowrap"
                    size="small"
                  >
                    {link.icon && (
                      <LinkIcon
                        className="text-base w-[16px] h-[16px]"
                        style={{ color: textColor }}
                      />
                    )}
                    <Text className="ml-1 block" style={{ color: textColor }}>
                      {link.name}
                    </Text>
                  </AntdBadge>
                </NavLink>
              );
            })}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:patients@curewiki.health"
              className="flex items-center justify-center px-0 bg-transparent"
            >
              <QuestionCircleOutlined className="text-base" style={{ color: textColor }} />
              <Text className="ml-1 block" style={{ color: textColor }}>
                {t('support.text')}
              </Text>
            </a>
            <Button
              danger
              onClick={() => logout()}
              className="flex items-center justify-center p-0 h-fit bg-transparent"
              type="text"
            >
              <SignOut className="text-error" />
              <Text className="ml-1 text-error block">{t('common.logout')}</Text>
            </Button>
          </div>
        }
        trigger="click"
        open={openMobileMenu}
        autoAdjustOverflow
        arrow={false}
        overlayClassName="w-screen"
        onOpenChange={setOpenMobileMenu}
      >
        <Button
          danger
          onClick={toggleOpenPopover}
          className={`flex items-center justify-center px-0 bg-transparent ${
            isYWC ? 'py-10' : 'py-4'
          } `}
          type="text"
        >
          <MenuOutlined className="text-base-600 text-2xl" />
        </Button>
      </AntdPopover>
    </AntdConfigProvider>
  );
};
